export default __webpack_public_path__ + "static/media/csat.c118132e.jpg";